import { Row, Col } from "../../components/Layout";
import { useState } from "react";
import { pickDays, transitDays, currencyPayload } from "../utility/constants";

export const QuoteFormElements = (props) => {
  const {
    selectedMachinesForQuote,
    onChange,
    formData
  } = props;

  const [touched , setTouched] = useState(false);
  const [selectedValue , setSelectedValue] = useState(0);
  const [selectedTransitDays , setSelectedTransitDays] = useState(0);
  const [selectedCurrency , setSelectedCurrency] = useState(0);
  const [textAreaCharCount, setTextAreaCharCount] = useState(0);


  const handlePickUpDaysChange = (e) => {
      setSelectedValue(e.target.value);
  }
  
  const handleTransitDays = (e) => {
    setSelectedTransitDays(e.target.value);
  }

  const handleCurrencyChange = (e) => {
    setSelectedCurrency(e.target.value);
  }

  const isValidAmount = !touched || ( formData.amount && formData.amount != null && (parseFloat(formData.amount) > 0 && parseFloat(formData.amount) < 100000 ));

  const handleBlur = () => {
    setTouched(true);
  }


  return (
    <div>
      <Row className="gap-6 mb-5">
        <Col className="text-base">
          <label
            id="quote-form-pld-label"
            className="text-xs mb-1 pr-[2%] required-field"
          >
            Pickup Days
          </label>
          <select
            className="border-[1px] p-[3px] border-gray-500 rounded-sm focus:shadow-md text-xs block "
            id="inputGroupSelect01"
            name="pickupdays"
            onChange={(e) => {
              onChange(e);
              handlePickUpDaysChange(e);
            }}
            value={selectedValue || selectedMachinesForQuote.pickupDays}
          >
            <option value="0" id="">
              Select Pickup Days
            </option>
            {pickDays.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </Col>

        <Col className="text-base">
          <label
            id="quote-form-pld-label"
            className="text-xs mb-1 pr-[2%] required-field"
          >
            Transit Days
          </label>
          <select
            className="border-[1px] p-[3px] border-gray-500 rounded-sm focus:shadow-md text-xs block "
            id="inputGroupSelect01"
            name="transitdays"
            onChange={(e) => {
              onChange(e);
              handleTransitDays(e);
            }}
            value={selectedTransitDays || selectedMachinesForQuote.transitDays}
          >
            <option value="0" id="">
              Select Transit Days
            </option>
            {transitDays.map((item) => (
              <option className="h-10" key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </Col>

        <Col className="text-base">
          <label
            id="quote-form-tp-label"
            className="text-xs mb-1 pr-[2%] required-field"
          >
            Amount
          </label>
          <div className="input-container">
            <input
              id="quote-form-tp-input"
              className="text-xs pr-[5.5%] border-[1px] border-gray-500 rounded-sm focus:shadow-md p-[3px] currency-input"
              name="amount"
              defaultValue={selectedMachinesForQuote.amount && selectedMachinesForQuote.amount.props ? selectedMachinesForQuote.amount.props.children[0] : ""}
              type="number"
              onChange={onChange}
              onBlur={handleBlur}
            />
          </div>
          {!isValidAmount && (
            <p
              id="quote-form-tp-err"
              className="text-xs text-red-500 mb-[-5%]"
            >
              Amount is invalid
            </p>
          )}
        </Col>
        <Col className="text-base">
          <label
            id="quote-form-pld-currency-label"
            className="text-xs mb-1 pr-[2%] required-field"
          >
            Currency
          </label>
          <select
            className="border-[1px] p-[3px] border-gray-500 rounded-sm focus:shadow-md text-xs block "
            id="inputCurrencyGroupSelect"
            name="currency"
            onChange={(e) => {
              onChange(e);
              handleCurrencyChange(e);
            }}
            value={selectedCurrency || selectedMachinesForQuote.currency}
          >           
            {Object.keys(currencyPayload).map((key) => (
                <option value={key} id={key}>
                {currencyPayload[key]}
              </option>
            ))}
          </select>
        </Col>
      </Row>
      <Row>
        <Col className="text-base flex-1">
          <label id="quote-form-tp-label" className="text-xs mb-1 pr-[2%]">
            Free Text
          </label>
          <textarea
            style={{ fontSize: 12, width: "100%", height: "8rem"}}
            className="text-xs p-2 w-full form-control focus:shadow-md border-2 border-gray-400 rounded-sm"
            placeholder="Please enter additional message here.."
            name="freetext"
            rows={3}
            onChange={(e) => {
              onChange(e);
              setTextAreaCharCount(e.target.value.length);
            }}
            defaultValue={selectedMachinesForQuote.freeText}
            maxLength="400"
          ></textarea>
          <p className="text-xs w-full text-right">{textAreaCharCount}/400</p>
        </Col>
      </Row>
    </div>
  );
};
